import { combineReducers } from 'redux-immutable';
import profileReducers from './profile/reducers';

export default combineReducers({
  profile: profileReducers,
});
